import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Upload, Users, ArrowUpRight, Activity, Lightbulb } from 'lucide-react';

const DashboardPage = () => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem('user') || "{}");
  const userName = currentUser.name || "User";

  return (
    <div className="p-6 max-w-6xl mx-auto space-y-6">
      {/* Banner Utama */}
      <div className="bg-white rounded-3xl p-8 shadow-sm border border-slate-100 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="space-y-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-indigo-50 text-indigo-600 rounded-full text-sm font-bold">
            ✨ Dashboard
          </div>
          <h1 className="text-4xl font-black text-slate-800">
            Selamat Siang, {userName}!
          </h1>
          <p className="text-slate-500 text-lg max-w-xl">
            Selamat datang di INVOICE C. Mari kelola data customer dan billing Anda dengan lebih produktif hari ini!
          </p>
          <div className="flex flex-wrap gap-4 pt-2">
            <button 
              onClick={() => navigate('/invoice-c/customers/import')} 
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-xl font-bold flex items-center gap-2 transition shadow-lg shadow-indigo-200"
            >
              <Upload size={20} /> Upload Data
            </button>
            <button 
              onClick={() => navigate('/invoice-c/customers/list')} 
              className="bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 px-6 py-3 rounded-xl font-bold flex items-center gap-2 transition"
            >
              <Users size={20} /> Lihat Customers
            </button>
          </div>
        </div>
        <div className="hidden md:flex w-40 h-40 bg-indigo-50 rounded-3xl items-center justify-center">
           <ArrowUpRight size={64} className="text-indigo-600" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Quick Actions */}
        <div className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm">
           <h3 className="font-bold text-slate-800 mb-4 text-lg">Quick Actions</h3>
           <div className="space-y-2">
              <button 
                onClick={() => navigate('/invoice-c/customers/import')} 
                className="w-full flex items-center gap-3 p-3 hover:bg-slate-50 rounded-xl transition text-slate-700 font-medium"
              >
                 <Upload size={18} className="text-slate-400" /> Import Customer Data
              </button>
              <button 
                onClick={() => navigate('/invoice-c/customers/list')} 
                className="w-full flex items-center gap-3 p-3 hover:bg-slate-50 rounded-xl transition text-slate-700 font-medium"
              >
                 <Users size={18} className="text-slate-400" /> Manage Customers
              </button>
           </div>
        </div>

        {/* Tips */}
        <div className="bg-indigo-50 p-6 rounded-3xl border border-indigo-100 shadow-sm">
           <h3 className="font-bold text-indigo-900 mb-4 text-lg flex items-center gap-2">
              <Lightbulb size={20} /> Tips
           </h3>
           <p className="text-indigo-700 font-medium leading-relaxed">
             Upload file Excel dengan format yang sesuai untuk import data customer secara batch.
           </p>
        </div>

        {/* System Status */}
        <div className="bg-emerald-50 p-6 rounded-3xl border border-emerald-100 shadow-sm">
           <h3 className="font-bold text-emerald-900 mb-4 text-lg flex items-center gap-2">
              <Activity size={20} /> System Status
           </h3>
           <div className="flex items-center gap-3 mt-2">
              <div className="relative flex h-4 w-4">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-4 w-4 bg-emerald-500"></span>
              </div>
              <span className="text-emerald-800 font-bold">All Systems Operational</span>
           </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;